// Drift-style hover zoom for the product media gallery (desktop only),
// matching retro51.com: a square bounding box follows the cursor over the
// product image while a separate pane shows the magnified area. The
// "Click to expand" button opens the fullscreen lightbox.
(function () {
  // Touch devices keep the native tap-to-expand lightbox instead.
  if (window.matchMedia('(hover: none)').matches) return;

  var MIN_BBOX = 120;
  var PANE_GAP = 24; // space between the image edge and the zoom pane

  var galleries = document.querySelectorAll('media-gallery[data-lens-zoom="true"]');
  if (!galleries.length) return;

  // Shared cursor state: mousemove is tracked document-wide, but the zoom
  // only activates while the cursor is over a gallery image.
  var lastCursorX = -1;
  var lastCursorY = -1;
  var cursorTracked = false;

  document.addEventListener(
    'mousemove',
    function (event) {
      lastCursorX = event.clientX;
      lastCursorY = event.clientY;
      cursorTracked = true;
    },
    true
  );

  galleries.forEach(function (gallery) {
    var pane = gallery.querySelector('[data-zoom-pane]');
    if (!pane) return;

    // Move the pane to <body> so `position: fixed` is never affected by
    // transformed/overflow-hidden ancestors, then park it off-screen until
    // the next hover positions it.
    document.body.appendChild(pane);
    pane.style.left = '-9999px';
    pane.style.top = '-9999px';

    var bbox = document.createElement('div');
    // The "zoom" class opts the box out of Dawn's generic
    // `.media > *:not(.zoom):not(...)` rule (base.css), which would otherwise
    // force `display: block` on it forever once appended — overriding our
    // `display: none` and leaving the box painted on the image after the
    // hover ends, even with the is-visible class removed.
    bbox.className = 'product__zoom-bounding-box zoom';
    bbox.setAttribute('aria-hidden', 'true');

    // The image element the zoom is currently active on. Dismissal safety
    // nets read its LIVE bounding rect, so layout shifts or re-renders can
    // never leave the zoom stuck on screen.
    var activeMediaEl = null;

    function hide() {
      bbox.classList.remove('is-visible');
      pane.classList.remove('is-visible');
      // Re-park the pane off-screen so it can never linger visibly between
      // hovers, even if it were shown again without being repositioned.
      pane.style.left = '-9999px';
      pane.style.top = '-9999px';
      activeMediaEl = null;
    }

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    // The active image is whichever media slide is hovered.
    function findImage(target) {
      var container = target.closest('.product-media-container');
      if (!container || !container.classList.contains('media-type-image')) return null;
      return container.querySelector('.product__media img');
    }

    function move(event) {
      var img = findImage(event.target);
      if (!img) {
        hide();
        return;
      }

      // .product__media is the positioned, overflow-hidden wrapper around the img
      var media = img.parentElement;
      var mediaRect = media.getBoundingClientRect();
      if (!mediaRect.width || !mediaRect.height) return;

      // Only keep the zoom alive while the cursor is REALLY over the image.
      // Mouse events can still reach the container after the pointer has
      // visually left the photo (overlaying elements, containers larger than
      // the image), and accepting them left the box/pane stuck on screen with
      // the box clamped to the nearest edge.
      var cursorX = event.clientX - mediaRect.left;
      var cursorY = event.clientY - mediaRect.top;
      if (
        cursorX < 0 ||
        cursorY < 0 ||
        cursorX > mediaRect.width ||
        cursorY > mediaRect.height
      ) {
        hide();
        return;
      }

      // Remember the active image element so the dismissal safety nets can
      // check the cursor against its LIVE bounding rect.
      activeMediaEl = media;

      if (bbox.parentElement !== media) media.appendChild(bbox);

      var bboxSize = Math.max(MIN_BBOX, Math.min(mediaRect.width / 3, mediaRect.height / 3));
      if (mediaRect.width < bboxSize || mediaRect.height < bboxSize) {
        hide();
        return;
      }

      // Keep the box fully inside the image
      var boxX = clamp(cursorX, bboxSize / 2, mediaRect.width - bboxSize / 2);
      var boxY = clamp(cursorY, bboxSize / 2, mediaRect.height - bboxSize / 2);

      bbox.style.width = bboxSize + 'px';
      bbox.style.height = bboxSize + 'px';
      bbox.style.left = boxX - bboxSize / 2 + 'px';
      bbox.style.top = boxY - bboxSize / 2 + 'px';
      bbox.classList.add('is-visible');

      pane.classList.add('is-visible');

      // Place the pane fully OUTSIDE the image: to its right by default,
      // flipped to the left when there is no room in the viewport, and
      // vertically aligned with (and clamped inside) the viewport.
      var paneWidth = pane.offsetWidth;
      var paneHeight = pane.offsetHeight;
      var viewportWidth = document.documentElement.clientWidth;
      var paneLeft = mediaRect.right + PANE_GAP;
      if (paneLeft + paneWidth > viewportWidth - 8) {
        paneLeft = mediaRect.left - paneWidth - PANE_GAP;
      }
      if (paneLeft < 8) paneLeft = 8;
      var paneTop = clamp(mediaRect.top, 8, Math.max(8, window.innerHeight - paneHeight - 8));

      pane.style.left = Math.round(paneLeft) + 'px';
      pane.style.top = Math.round(paneTop) + 'px';

      // The <img> is `object-fit: cover`, so whenever its natural aspect
      // ratio doesn't match the frame's aspect ratio, part of the image is
      // cropped out of view. The background image used for the zoom pane is
      // the FULL, uncropped photo, so we have to reproduce that same crop
      // here — otherwise the pane shows a differently-framed (and often
      // misaligned/blurry-looking) slice of the picture than what's on
      // screen, which is why things near the edges (like the pencil tip)
      // never line up.
      var naturalWidth = img.naturalWidth || mediaRect.width;
      var naturalHeight = img.naturalHeight || mediaRect.height;
      var naturalAspect = naturalWidth / naturalHeight;
      var frameAspect = mediaRect.width / mediaRect.height;

      var renderedWidth;
      var renderedHeight;
      if (naturalAspect > frameAspect) {
        // Image is relatively wider than the frame: cropped on the sides.
        renderedHeight = mediaRect.height;
        renderedWidth = renderedHeight * naturalAspect;
      } else {
        // Image is relatively taller than the frame: cropped top/bottom.
        renderedWidth = mediaRect.width;
        renderedHeight = renderedWidth / naturalAspect;
      }

      // How far the crop pushes the image's top-left corner outside the
      // frame on each axis (0 when that axis isn't cropped).
      var cropOffsetX = (renderedWidth - mediaRect.width) / 2;
      var cropOffsetY = (renderedHeight - mediaRect.height) / 2;

      pane.style.backgroundImage = "url('" + (img.dataset.zoomSrc || img.currentSrc) + "')";

      // Magnify the bounding box to fill the pane EXACTLY. The pane's edges
      // then always line up with the bounding box's edges, so the highlighted
      // area on the photo is precisely what appears in the pane — the product
      // is never sliced mid-way inside the pane; it is only "cut" where the
      // bounding box (i.e. the photo frame) ends. Using a fixed zoom factor
      // here instead made the pane show a smaller region than the box
      // promised, which visibly chopped the product at the pane's edges.
      var scaleX = paneWidth / bboxSize;
      var scaleY = paneHeight / bboxSize;
      pane.style.backgroundSize =
        Math.round(renderedWidth * scaleX) + 'px ' + Math.round(renderedHeight * scaleY) + 'px';
      pane.style.backgroundPosition =
        Math.round(-((boxX - bboxSize / 2) + cropOffsetX) * scaleX) +
        'px ' +
        Math.round(-((boxY - bboxSize / 2) + cropOffsetY) * scaleY) +
        'px';
    }

    // Hover logic: mouseenter/mousemove/mouseleave are bound to the media
    // CONTAINER (.product-media-container). The invisible lightbox toggle
    // (.product__media-toggle) sits on top of the image and captures mouse
    // events, but they bubble up to the container — so events always reach
    // us while hovering the image, and mouseleave always fires when the
    // cursor leaves it.
    gallery.querySelectorAll('.product-media-container').forEach(function (container) {
      container.addEventListener('mouseenter', move);
      container.addEventListener('mousemove', move);
      container.addEventListener('mouseleave', hide);
    });

    // Safety net 1: if mouseleave was somehow missed (fast cursor movement,
    // synthetic events), a watcher that runs only while the zoom is visible
    // verifies that the cursor is still inside the ACTIVE image's LIVE
    // bounding rect and hides otherwise — box AND pane together.
    setInterval(function () {
      if (!activeMediaEl) return;
      // Run while EITHER part of the zoom is on screen, so a half-hidden
      // state (pane gone, box stuck) can never disable this safety net.
      if (!pane.classList.contains('is-visible') && !bbox.classList.contains('is-visible')) return;
      if (!cursorTracked) return;
      var liveRect = activeMediaEl.getBoundingClientRect();
      if (!liveRect.width || !liveRect.height) {
        // The image element is gone (e.g. the gallery was re-rendered).
        hide();
        return;
      }
      var inside =
        lastCursorX >= liveRect.left &&
        lastCursorX <= liveRect.right &&
        lastCursorY >= liveRect.top &&
        lastCursorY <= liveRect.bottom;
      if (!inside) hide();
    }, 100);

    // Safety net 2 (the decisive one): EVERY mousemove anywhere in the
    // document is checked against the live image rect while the zoom is
    // visible. This does not depend on mouseleave firing or on the media
    // container receiving any event, so the moment the pointer moves off the
    // image — onto a gap, an overlay, another column, anywhere — the
    // bounding box and the zoom pane vanish instantly.
    document.addEventListener(
      'mousemove',
      function (event) {
        if (!activeMediaEl) return;
        if (!pane.classList.contains('is-visible') && !bbox.classList.contains('is-visible')) return;
        var liveRect = activeMediaEl.getBoundingClientRect();
        if (
          event.clientX < liveRect.left ||
          event.clientX > liveRect.right ||
          event.clientY < liveRect.top ||
          event.clientY > liveRect.bottom
        ) {
          hide();
        }
      },
      true
    );

    window.addEventListener('scroll', hide, true);
    window.addEventListener('resize', hide);
    // Losing the window (alt-tab, clicking a second monitor) strands the zoom
    // on screen because no further mouse events arrive; dismiss it.
    window.addEventListener('blur', hide);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) hide();
    });

    // Opening the lightbox should immediately dismiss the hover zoom.
    gallery.addEventListener('click', function (event) {
      if (event.target.closest('.product__expand-btn, .product__media-toggle, .product__media-icon')) hide();
    });
  });

  // The "Click to expand" buttons open the fullscreen lightbox. (The theme's
  // modal-opener only wires up its first button, so these get their own.)
  document.querySelectorAll('.product__expand-btn').forEach(function (button) {
    button.addEventListener('click', function () {
      var opener = button.closest('modal-opener');
      if (!opener) return;
      var modal = document.querySelector(opener.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  });
})();
